import { Moon, Dumbbell, BookOpen, Briefcase, Wine, Brain } from 'lucide-react'

export type Category = 'sleep' | 'exercise' | 'reading' | 'work' | 'drunk' | 'meditation'

export interface CategoryConfig {
  key: Category
  label: string
  icon: React.ComponentType<{ className?: string }>
  color: string
  lightColor: string
  darkColor: string
  bgColor: string
  gradient: string
  detailsFields: DetailField[]
}

export interface DetailField {
  key: string
  label: string
  placeholder: string
  type: 'text' | 'select' | 'rating'
  options?: { label: string; value: string }[]
}

export const CATEGORIES: CategoryConfig[] = [
  {
    key: 'sleep',
    label: '睡觉',
    icon: Moon,
    color: '#8B5CF6',
    lightColor: '#C4B5FD',
    darkColor: '#6D28D9',
    bgColor: '#F5F3FF',
    gradient: 'from-violet-500 to-purple-600',
    detailsFields: [
      { key: 'quality', label: '睡眠质量', placeholder: '选择睡眠质量', type: 'select', options: [
        { label: '非常好', value: 'excellent' },
        { label: '较好', value: 'good' },
        { label: '一般', value: 'normal' },
        { label: '较差', value: 'poor' },
      ]},
      { key: 'note', label: '备注', placeholder: '做梦了、失眠了...', type: 'text' },
    ],
  },
  {
    key: 'exercise',
    label: '运动',
    icon: Dumbbell,
    color: '#10B981',
    lightColor: '#6EE7B7',
    darkColor: '#059669',
    bgColor: '#ECFDF5',
    gradient: 'from-emerald-500 to-green-600',
    detailsFields: [
      { key: 'type', label: '运动类型', placeholder: '如跑步、游泳、瑜伽', type: 'text' },
      { key: 'intensity', label: '强度', placeholder: '选择运动强度', type: 'select', options: [
        { label: '低强度', value: 'low' },
        { label: '中强度', value: 'medium' },
        { label: '高强度', value: 'high' },
      ]},
    ],
  },
  {
    key: 'reading',
    label: '读书',
    icon: BookOpen,
    color: '#3B82F6',
    lightColor: '#93C5FD',
    darkColor: '#2563EB',
    bgColor: '#EFF6FF',
    gradient: 'from-blue-500 to-indigo-600',
    detailsFields: [
      { key: 'bookName', label: '书名', placeholder: '读什么书', type: 'text' },
      { key: 'pages', label: '页数', placeholder: '读了多少页', type: 'text' },
      { key: 'note', label: '笔记/感想', placeholder: '有什么收获', type: 'text' },
    ],
  },
  {
    key: 'work',
    label: '工作',
    icon: Briefcase,
    color: '#F59E0B',
    lightColor: '#FCD34D',
    darkColor: '#D97706',
    bgColor: '#FFFBEB',
    gradient: 'from-amber-500 to-orange-600',
    detailsFields: [
      { key: 'task', label: '工作内容', placeholder: '做了什么', type: 'text' },
      { key: 'note', label: '备注', placeholder: '进度、问题等', type: 'text' },
    ],
  },
  {
    key: 'drunk',
    label: '微醺',
    icon: Wine,
    color: '#EC4899',
    lightColor: '#F9A8D4',
    darkColor: '#DB2777',
    bgColor: '#FDF2F8',
    gradient: 'from-pink-500 to-rose-600',
    detailsFields: [
      { key: 'drink', label: '饮品', placeholder: '啤酒、红酒、鸡尾酒', type: 'text' },
      { key: 'amount', label: '用量', placeholder: '如一杯、两瓶', type: 'text' },
      { key: 'note', label: '感受', placeholder: '微醺的感觉', type: 'text' },
    ],
  },
  {
    key: 'meditation',
    label: '冥想',
    icon: Brain,
    color: '#6366F1',
    lightColor: '#A5B4FC',
    darkColor: '#4F46E5',
    bgColor: '#EEF2FF',
    gradient: 'from-indigo-500 to-violet-600',
    detailsFields: [
      { key: 'method', label: '冥想方式', placeholder: '如呼吸法、身体扫描', type: 'text' },
      { key: 'note', label: '感受', placeholder: '冥想体验', type: 'text' },
    ],
  },
]

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map(c => [c.key, c])) as Record<Category, CategoryConfig>

export const QUALITY_LABELS: Record<string, string> = {
  excellent: '非常好',
  good: '较好',
  normal: '一般',
  poor: '较差',
}

export const INTENSITY_LABELS: Record<string, string> = {
  low: '低强度',
  medium: '中强度',
  high: '高强度',
}
